export default (diagAngle: number, rotateAngle: number) => {
  const ang1 = Math.PI / 2 - diagAngle - rotateAngle;
  const ang2 = Math.abs(diagAngle - rotateAngle);
  return { ang1, ang2 };
};
